<template>
  <div :class="classes()">
    <div v-if="$slots.headline || headline" :class="`${el}__head`">
      <slot v-if="$slots.headline" name="headline" />
      <Headline v-if="headline" :headine="3" size="xs" noMargin>
        {{ headline }}
      </Headline>
    </div>
    <Divider v-if="hasHeadlineDivider" dotted />
    <div :class="`${el}__inner`">
      <slot />
    </div>
    <div :class="`${el}__bottomWrapper`" v-if="bottom || $slots.bottom">
      <Divider dotted />
      <div :class="`${el}__bottom`">
        <slot v-if="$slots.bottom" name="bottom" />
        <template v-else>
          <Button
            v-if="bottomIsButton"
            :href="bottom.href"
            :onClick="bottom.onClick"
            :label="bottom.label"
            :disabled="bottom.disabled"
            :type="bottom.buttonType"
            :additionalIconName="bottomIconName"
            :additionalIconPos="bottomIconPos"
            small
          />
          <Link
            v-else
            :to="bottom.href"
            :icon="bottomIconName"
            :iconPos="bottomIconPos"
            :onClick="bottom.onClick"
            noUnderline
          >
            {{ bottom.label }}
          </Link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Button from '@/objects/Button';
import Link from '@/objects/Link';
import Divider from '@/objects/Divider';

import { IconNameTypes } from '@/constants/enums';

export default {
  name: 'Widget',
  props: {
    headline: String,
    bottom: {
      href: String,
      onClick: {
        type: Function,
        default: () => {},
      },
      label: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      buttonType: {
        type: String,
        default: 'primary',
        validator: (val) => ['primary', 'secondary', 'outlined', 'text'].includes(val),
      },
    },
    bottomIconName: {
      type: String,
      validator: (val) => IconNameTypes.includes(val),
      default: 'arrow-right-line',
    },
    bottomIconPos: {
      type: String,
      default: 'right',
    },
    bottomIsButton: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    hasHeadlineDivider: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Headline,
    Button,
    Link,
    Divider,
  },
  data() {
    return {
      el: 'o-widget',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--bordered`]: this.bordered,
          [`${el}--hasHeadlineDivider`]: this.hasHeadlineDivider,
        };
      },
    };
  },
};
</script>
